import { CHECKOUT_FETCH_REQUEST, CHECKOUT_FETCH_SUCCESS, CHECKOUT_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchCheckoutRequest = () => {
    return {
        type: CHECKOUT_FETCH_REQUEST
    }
}

const fetchCheckoutSuccess = data => {
    return {
        type: CHECKOUT_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchCheckoutFailure = error => {
    return {
        type: CHECKOUT_FETCH_FAILURE,
        payload: error,
    }
}

export const getCheckout = (slug, step) => {
    return (dispatch) => {
        dispatch(fetchCheckoutRequest());
        fetch(`${baseUrl}/projects/${slug}/photographers?step=${step}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchCheckoutSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchCheckoutFailure(error.message));
            })
    }
}